import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faPlay, faAngleLeft, faAngleRight, faEnvelope, faPrint, faFilePdf, faLink, faTimes } from '@fortawesome/pro-light-svg-icons'
library.add(fab, faPlay, faAngleLeft, faAngleRight, faEnvelope, faPrint, faFilePdf, faLink, faTimes)
